import { Menu, Status } from "@common/models";
import { Field } from "./field";

export class FieldMenuId {
    field: Field;
    menu: Menu;
}

export class FieldMenu {
    id: FieldMenuId;
    status: Status;
    createdAt: Date;
    createdUserId: Number;
    updatedAt: Date;
    updatedUserId: Number;
}
